import { render, staticRenderFns } from "./GameShow.vue?vue&type=template&id=d76f51be&scoped=true"
import script from "./GameShow.vue?vue&type=script&lang=js"
export * from "./GameShow.vue?vue&type=script&lang=js"
import style0 from "./GameShow.vue?vue&type=style&index=0&id=d76f51be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76f51be",
  null
  
)

export default component.exports